export default {
	penalty: 'عقوبة',
	reward: 'مكافآة',
	'add-penalty': 'إضافة عقوبة',
	'add-reward': 'إضافة مكافأة',
	'delete-message-penalty': 'هل أنت متأكد أنك تريد حذف عقوبة من نوع',
	'delete-message-bonus': 'هل أنت متأكد من أنك تريد حذف مكافآة من نوع '
};
